import { memo } from "react";
import { StackRibbonProps } from "../types";

const STROKE_COLOR = "darkgrey";
const STROKE_WIDTH = 0.0;
const STROKE_OPACITY = 0.5;

const StackRibbon = ({
  series,
  seriesKey,
  areaGenerator,
  useId,
  colorMap,
  onMouseEnter,
  onMouseLeave,
}: StackRibbonProps) => {
  const useColor = colorMap.get(useId);

  return (
    <g
      data-ribbon-key={seriesKey}
      onMouseEnter={() =>
        onMouseEnter({ seriesKey, series, fillColor: useColor! })
      }
      onMouseLeave={onMouseLeave}
    >
      <path
        d={areaGenerator(series)}
        fill={useColor}
        stroke={STROKE_COLOR}
        strokeWidth={STROKE_WIDTH}
        strokeOpacity={STROKE_OPACITY}
      />
    </g>
  );
};

export default memo(StackRibbon);
